import HeaderTittle from './HeaderTittle';

export default HeaderTittle;
